import { Tooltip, Typography, alpha } from "@mui/material";
import React from "react";

interface Props {
  children: React.ReactElement<any, any>;
  visible?: boolean;
}
const DisabledCheckInTooltip = ({ children, visible = false }: Props) => {
  return (
    <Tooltip
      title={
        visible ? (
          <>
            <Typography fontWeight="bold" variant="body1">
              Check-In Preview
            </Typography>
            <Typography variant="body2">
              This is how your client will see and answer this question during
              their check-in.
            </Typography>
          </>
        ) : undefined
      }
      followCursor
      placement="top-start"
      enterDelay={500}
      enterNextDelay={1500}
      slotProps={{
        tooltip: {
          sx: {
            px: 1,
            py: 0.8,
            fontSize: 12,
            bgcolor: (theme) => alpha(theme.palette.text.primary, 0.7),
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default DisabledCheckInTooltip;
